import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable()
export class FakeLocaleInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('/ctl/auth/locale/en')) {
      console.warn('[FakeLocaleInterceptor] Mocking response for:', req.url);
      return of(
        new HttpResponse({
          status: 200,
          body: {
            'header.application': 'Application',
          },
        })
      );
    }

    return next.handle(req);
  }
}
